export default __webpack_public_path__ + "static/media/russia.540c86d9.svg";